import React from 'react';
import { Link } from 'react-router-dom';
import LogoZkcandyWhite from '../Assets/logo-zkcandy-white.svg';
import IconX from '../Assets/icon-x.svg';
import IconTelegram from '../Assets/icon-telegram.svg';
import IconDiscord from '../Assets/icon-discord.svg';
import IconMedium from '../Assets/icon-medium.svg';
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import Moon from '../Assets/moon.webp';

const Footer = () => {
  const community = [
    { img: IconX, name: 'X', path: 'https://x.com/ZKcandyHQ' },
    { img: IconDiscord, name: 'Discord', path: 'https://discord.com/invite/zkcandy' },
    { img: IconTelegram, name: 'Telegram', path: 'https://t.me/zkcandy' },
    { img: IconMedium, name: 'Medium', path: 'https://zkcandy.medium.com/' },
  ]

  const resources = [
    { name: 'Portal', path: 'https://portal.zkcandy.io/' },
    { name: 'Docs', path: 'https://docs.zkcandyapi.com/' },
    { name: 'Block Explorer', path: 'https://explorer.zkcandy.io/' },
    { name: 'Terms of Service', path: '' },
  ]

  return (
    <footer className="footer text-white py-5">
      {/* <img className="absolute left-1/2 transform -translate-x-1/2 bottom-0 w-full" src={Moon} alt="Footer Background" /> */}
      <div className="container mx-auto relative px-4">
        <div className="footer-content flex flex-col justify-between items-center">
          <div className="flex justify-between flex-row w-full">
            <img className="lg:w-[200px] w-[110px]" src={LogoZkcandyWhite} alt="ZKcandy" />
            <div className="hidden lg:flex lg:flex-row lg:space-x-10 font-inversionz text-[1.5rem] lg:text-[1.6em] tracking-[-5px]">
              {resources.map((link, index) => (
                <Link key={index} to={link.path} className="w-full whitespace-nowrap font-inversionz flex items-center">
                  <ArrowUpRightIcon className="size-4 me-1" />
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex justify-between items-center flex-row w-full mt-1">
            <div>
              <span className="font-inversionz text-[1.3rem] lg:text-[1.6rem] tracking-[-5px]"> Copyright </span>
              <span className="text-[1rem] lg:text-[1.3rem]">&copy;</span>
              <span className="text-[1.3rem] font-inversionz lg:text-[1.6rem] tracking-[-5px]">{new Date().getFullYear()} ZKcandy</span>
            </div>

            <div className="flex flex-row space-x-2 lg:space-x-5">
              {community.map((link, index) => (
                <Link key={index} to={link.path} className="w-full">
                  <img src={link.img} alt={link.name} className="w-[20px] lg:w-[28px]" />
                </Link>
              ))}
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;